module.exports = __webpack_public_path__ + "static/media/text.95b25eb1.svg";